const PERSONALITY_SURVEYS_QUESTIONS = 26;
const REST_OF_SURVEY_STEPS = 4;

export const getStepProgress = (currentStep: number) => {
  const maxStep = PERSONALITY_SURVEYS_QUESTIONS + REST_OF_SURVEY_STEPS;

  return Math.floor(((PERSONALITY_SURVEYS_QUESTIONS + currentStep) / maxStep) * 100);
};
